<template>
	<transition name="slide-fade" mode="out-in">
    	<div class="contain bg-day">
    		<!-- 10月礼品 -->
    		<div class="top-bg">
    			<div class="height-56"></div>
    			<div class="prize-bg" v-show="tkRotate">
    				<div class="prize-flag">{{prizeInfo.prizeId==82 || prizeInfo.prizeId==84?'很遗憾':'中奖啦'}}</div>
					<div class="prize-name">{{prizeInfo.prizeName}}</div>
	    			<div class="prize-ball"><img class="width-260" :src="require('../../../images/memberDay/prize'+prizeInfo.prizeId+'.png')"></div>
		    		<div class="prize-input-box">
		    			<div v-if="prizeInfo.prizeId==70">
		    				<div class="padding-t-20 padding-b-20 color-fff" >
		    					<div class="size-16">旗开得胜，一鸣惊人</div>
		    					<div class="padding-t-20">输入访问密码【wCxY】领取</div>
		    				</div>
		    			</div>
		    			<div v-else-if="prizeInfo.prizeId==77 || prizeInfo.prizeId==78">
		    				<div class=" margin-t-20"></div>
		    				<div class="height-32"></div>
		    				<div v-if="accountPower && prizeInfo.status==0">是否授权当前{{prizeInfo.accountName | changeStar}}账号广材网7天VIP权益</div>
		    				<div v-if="!accountPower && prizeInfo.status==0">请填写广联达账号,点击确定立即生效</div>
		    				<div class="height-32"></div>
		    				<div class="prize-account-power" v-if="!accountPower && prizeInfo.status==0">
		    					<div class="flex-row2 border-b-999 height-40" v-if="(prizeInfo.prizeId==77 || prizeInfo.prizeId==78) && !accountPower">
							        <div>
							            <img class="width-24" src="../../../images/icon/icon-name.png">
							        </div>
							        <div>
							            <input v-focus placeholder="请输入您的账号" type="text" v-model.trim="account" :disabled="onlyRead">
							        </div>
							    </div>
		    				</div>
		    				<div class="padding-t-20 padding-b-20" v-if="prizeInfo.status==1">已授权{{prizeInfo.name | changeStar}}账号广材网7天VIP权益</div>
		    				<!-- <div class="flex-row2 border-b-999 height-56" v-if="prizeInfo.prizeId==71 && !accountPower">
						        <div>
						            <img class="width-24" src="../../../images/icon/icon-name.png">
						        </div>
						        <div>
						            <input v-focus placeholder="请输入您的账号" type="text" v-model.trim="account" :disabled="onlyRead">
						        </div>
						    </div> -->
	    				</div>
	    				<div v-else-if="prizeInfo.prizeId==82">
		    				<div class="padding-t-20 padding-b-20 color-fff" >
		    					<div class="size-16">累计完成5天签到</div>
		    					<div class="padding-t-20">就有机会赢苹果AirPsds Pro！</div>
		    				</div>
	    				</div>
	    				<div v-else-if="prizeInfo.prizeId==84">
		    				<div class="padding-t-20 padding-b-20 color-fff" >
		    					<div class="size-16">每天登录产品赢积分</div>
		    					<div class="padding-t-20">积分越高12月会员日中奖率越高</div>
		    				</div>
	    				</div>
	    				<div v-else>
						    <div class="flex-row2 border-b-999 height-40">
						        <div>
						            <img class="width-24" src="../../../images/icon/icon-name.png">
						        </div>
						        <div>
						            <input v-focus placeholder="请输入您的姓名" type="text" v-model.trim="name"  :disabled="onlyRead">
						        </div>
						    </div>
						    <div class="flex-row2 border-b-999 height-40">
						        <div>
						            <img class="width-24" src="../../../images/icon/icon-phone.png">
						        </div>
						        <div>
						            <input v-focus placeholder="请输入您的手机号码" type="text" v-model.trim="phone" :disabled="onlyRead">
						        </div>
						    </div>
						    <div class="flex-row2 border-b-999 height-40">
						        <div>
						            <img class="width-24" src="../../../images/icon/icon-address.png">
						        </div>
						        <div>
						            <input v-focus placeholder="请输入省/市/区/等详细收货地址" type="text" v-model.trim="address" :disabled="onlyRead">
						        </div>
						    </div>	
							<div class="prize-tips">
								<div>未填写个人信息, 视为自动放弃奖品</div>
							</div>
	    				</div>
		    			
					    <!-- <div class="flex-row2 border-b-999 height-56" v-show="prizeInfo.prizeId==65">
					        <div>
					            <img class="width-24" src="../../../images/icon/icon-address-white.png">
					        </div>
					        <div @click="clickArea()">
					            <input v-focus placeholder="请选择您的地区" type="text" v-model.trim="area">
					        </div>
					        <mt-popup v-model="showAreaSelect"  
					        		  popup-transition="popup-fade" 
					        		  position="bottom"  
					        		  style="width: 100%;" >
				        		<div class="picker-toolbar border-b-1">
				        		  	<span class="mint-datetime-action mint-datetime-cancel" @click="showAreaSelect=false">取消</span> 
				        		  	<span class="mint-datetime-action mint-datetime-confirm" @click="areaConfirm()">确定</span>
				        		</div>
							    <mt-picker :slots="areaSlots" 
							    		   value-key="name" 
							    		   @change="areaChange">
							    </mt-picker>
							</mt-popup>
					    </div> -->
					</div>
    				<div class="prize-rotate" @click="tkRotate=!tkRotate"></div>
    			</div>
    			<div class="tk-rotate" v-show="!tkRotate" @click="tkRotate=!tkRotate">
	    			<img :src="require(`../../../images/memberDay/max${prizeInfo.cards}.png`)">
	    		</div>
			</div>
			<div v-if="prizeInfo.status==0">
				<div class="prize-btn-box flex-row4" v-if="prizeInfo.prizeId==70" @click="confimDownload()">
					<div>立即下载</div>
				</div>
				<div class="prize-btn-box flex-row2" v-else-if="(prizeInfo.prizeId==77 || prizeInfo.prizeId==78) && accountPower">
					<div class="width50" @click="accountPower=false">授权其他账号</div>
					<div class="prize-btn-center"></div>
					<div class="width50" @click="confirmAccount(1)">是（点击立即生效）</div>
				</div>
				<div class="prize-btn-box flex-row4" v-else-if="(prizeInfo.prizeId==77 || prizeInfo.prizeId==78) && !accountPower" @click="confirmAccount(2)">
					<div>提交</div>
				</div>
				<div class="prize-btn-box flex-row4" v-else-if="prizeInfo.prizeId==82 || prizeInfo.prizeId==84" @click="back()">
					<div>知道啦</div>
				</div>
				<div class="prize-btn-box flex-row4" @click="confimSend()" v-else>
					<div>提交</div>
				</div>
			</div>
			<div class="prize-btn-box bg-DAE6C8 flex-row4" v-if="prizeInfo.status==1">
				<div class="width100">已提交</div>
			</div>
			<loading v-show="showLoading"></loading>
    	</div>
	</transition>
</template>

<style lang="less" scoped>
@import "../../../style/variable.less";
@import "./style.less";
</style>

<script>
module.exports = require("./index.js")
</script>